import Reveal from "./Reveal";

/**
 * Consistent animated section header: a glassy eyebrow pill, a gradient
 * title, and an optional subtitle.
 */
export default function SectionHeading({
  eyebrow,
  title,
  subtitle,
  align = "center",
}) {
  const alignment =
    align === "left" ? "items-start text-left" : "items-center text-center";

  return (
    <div className={`mb-14 flex flex-col gap-5 ${alignment}`}>
      {eyebrow && (
        <Reveal direction="up">
          <span className="inline-flex items-center gap-2 rounded-full border border-hairline bg-fill px-4 py-1.5 text-xs font-medium uppercase tracking-[0.28em] text-content backdrop-blur-md">
            <span className="h-1.5 w-1.5 rounded-full bg-content shadow-glow-cyan animate-pulse-glow" />
            {eyebrow}
          </span>
        </Reveal>
      )}

      <Reveal direction="up" delay={0.06}>
        <h2 className="text-4xl font-bold leading-[1.05] tracking-tight md:text-6xl">
          <span className="text-gradient">{title}</span>
        </h2>
      </Reveal>

      {subtitle && (
        <Reveal direction="up" delay={0.12}>
          <p className="max-w-2xl text-base leading-relaxed text-muted md:text-lg">
            {subtitle}
          </p>
        </Reveal>
      )}
    </div>
  );
}
